import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component({})
export default class IaElementsProps extends Vue {
  @Prop({ type: Object as PropType<IaElementsInterface>, default: () => {} })
  template!: IaElementsInterface;
}
